/**
 * Get spreadSheet url
 */
function getGoogleSpreadSheetUrl(dataSource) {
    // need to check in the 3 formats that we use
    const gssDataSourceId = dataSource.channelId ?? dataSource.dataSourceId ?? dataSource.spreadsheetId ?? dataSource.asset?.id;
    if (!gssDataSourceId) {
        throw 'Invalid data source';
    }
    const url = `https://docs.google.com/spreadsheets/d/${gssDataSourceId.replace('/0', '')}`;
    return url;
}

module.exports = { getGoogleSpreadSheetUrl };